// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActivateAccount_loginContainer__pXrtx {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f4f6f9;
  padding: 1rem;
}

.ActivateAccount_loginCard__LhCMk {
  background-color: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 400px;
}

.ActivateAccount_loginTitle__zoAy2 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #333;
  text-align: center;
  padding: 1rem;
}

.ActivateAccount_loginSubtitle__WCk9r {
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 1.5rem;
  line-height: 1.4;
  text-align: center;
}

.ActivateAccount_loginForm__VfQmK {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ActivateAccount_errorMessage__vJtTF {
  color: #6c757d;
  margin-bottom: 2rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.ActivateAccount_loadingText__g3OAS {
  margin-top: 1rem;
  color: #6c757d;
}

.ActivateAccount_submittingOverlay__HXtvj {
  text-align: center;
  margin-top: 1rem;
  color: #007bff;
}
.ActivateAccount_submittingOverlay__HXtvj p {
  margin-top: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/ActivateAccount/ActivateAccount.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;AACJ;;AAGA;EACI,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;;AAGA;EACI,cAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAEI;EACI,kBAAA;AAAR","sourcesContent":[".loginContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 100vh;\r\n    background-color: #f4f6f9;\r\n    padding: 1rem;\r\n\r\n}\r\n\r\n.loginCard {\r\n    background-color: #fff;\r\n    padding: 2rem;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n    width: 100%;\r\n    max-width: 400px;\r\n}\r\n\r\n.loginTitle {\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n    margin-bottom: 1.5rem;\r\n    color: #333;\r\n    text-align: center;\r\n    padding: 1rem;\r\n}\r\n\r\n.loginSubtitle {\r\n    font-size: 0.95rem;\r\n    color: #666;\r\n    margin-bottom: 1.5rem;\r\n    line-height: 1.4;\r\n    text-align: center;\r\n}\r\n\r\n.loginForm {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n}\r\n\r\n.errorMessage {\r\n    color: #6c757d;\r\n    margin-bottom: 2rem;\r\n    padding: 1rem;\r\n    background-color: #f8f9fa;\r\n    border-radius: 8px;\r\n    border: 1px solid #e9ecef;\r\n}\r\n\r\n.loadingText {\r\n    margin-top: 1rem;\r\n    color: #6c757d;\r\n}\r\n\r\n.submittingOverlay {\r\n    text-align: center;\r\n    margin-top: 1rem;\r\n    color: #007bff;\r\n\r\n    p {\r\n        margin-top: 0.5rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginContainer": `ActivateAccount_loginContainer__pXrtx`,
	"loginCard": `ActivateAccount_loginCard__LhCMk`,
	"loginTitle": `ActivateAccount_loginTitle__zoAy2`,
	"loginSubtitle": `ActivateAccount_loginSubtitle__WCk9r`,
	"loginForm": `ActivateAccount_loginForm__VfQmK`,
	"errorMessage": `ActivateAccount_errorMessage__vJtTF`,
	"loadingText": `ActivateAccount_loadingText__g3OAS`,
	"submittingOverlay": `ActivateAccount_submittingOverlay__HXtvj`
};
export default ___CSS_LOADER_EXPORT___;
